import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MyApplicationsService } from '@app/pages/my-application/my-app-service.service';
import { HttpService } from '@app/@core/services/http.service';
import { LocalService } from '@app/@core/services/local.service';

import { CommonService } from '@app/shared/services/common.service';

@Component({
  standalone: false,
  selector: 'app-fee-and-payment',
  templateUrl: './fee-and-payment.component.html',
  styleUrls: ['./fee-and-payment.component.scss']
})
export class FeeAndPaymentComponent implements OnInit { 
  name: string = 'Fee and Payment';
  showModal: boolean = false;
  paymentSuccess: boolean = false;
  applicationStatusData: any;
  personData: any;
  applicationID: any;
  applicationTotalFee: number | null = null;
  LiceanceEndrosementFee: string | null = null;
  applicationFee: number | null = null;
  backgroundCheckFee: string | null = null;
  VeteranExemption: string | null = null;
  endorsementUnitFee = 0;
  endorsementCount = 0;

  constructor(
    private readonly router: Router,
    private readonly appService: MyApplicationsService,
    private readonly httpService: HttpService,
    private readonly sessionStorage: LocalService,
    private readonly commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.httpService.get('/domain/lookup?requestType=APPLICATION_STATUS').subscribe({
      next: (item: any) => {
        this.applicationStatusData = item.data;
      },
      error: error => {
        console.error('Error loading dropdown data:', error);
      }
    });
    const applicationFeeRaw = this.sessionStorage.getItem('applicationFee');
    this.LiceanceEndrosementFee = this.sessionStorage.getItem('LiceanceEndrosementFee');
    this.endorsementUnitFee = parseFloat(this.sessionStorage.getItem('additionalEndorsementUnitFee') || '0') || 0;
    this.endorsementCount = Number(this.sessionStorage.getItem('additionalEndorsementCount')) || 0;
    this.backgroundCheckFee = this.sessionStorage.getItem('backgroundCheckFee');
    this.VeteranExemption = this.sessionStorage.getItem('Veteran Exemption');

    const appFeeNum = parseFloat(applicationFeeRaw) || 0;
    const bgCheckFeeNum = parseFloat(this.backgroundCheckFee) || 0;
    const endorsementFeeNum = parseFloat(this.LiceanceEndrosementFee) || 0;
    const veteranExemptionNum = parseFloat(this.VeteranExemption) || 0;
    // Background check fee is mandatory — roll into Application Fee display.
    this.applicationFee = appFeeNum + bgCheckFeeNum;
    this.applicationTotalFee = appFeeNum + bgCheckFeeNum + endorsementFeeNum - veteranExemptionNum;
    const personDataString = this.sessionStorage.getItem('personData');
    this.personData = personDataString ? JSON.parse(personDataString) : null;
    
    const applicationIDString = this.sessionStorage.getItem('applicationID');
    this.applicationID = applicationIDString ? JSON.parse(applicationIDString) : null;
  }

  showPaymentSuccessModal(): void {
    this.showModal = true;
    this.paymentSuccess = true;
    setTimeout(() => {
      this.updateApplicationStatus();
      this.createApplicationTimeline(); 
      this.closeModal();
      this.router.navigate(['pages/my-app']);
    }, 5000);
  }

  createApplicationTimeline(): void {
   
    const draftStatusKey = this.findKeyByValue(this.applicationStatusData, 'SUBMITTED');
    const applicationTimelineData = {
      application_id: this.applicationID,
      cd_application_status: draftStatusKey,
      person_id: this.personData.person_id,
    };
    
    // this.appService.createApplicationTimeline(applicationTimelineData).subscribe({
    //   next: response => {
    //     if (response.data.success === true) {
    //       console.log('Application timeline created successfully:', response);
    //     } else {
    //       console.warn('Application timeline creation returned false success status');
    //     }
    //   },
    //   error: error => {
    //     console.error('Error creating application timeline:', error);
    //   }
    // });
  }

  findKeyByValue(data: any, value: string): any {
    if (!data || !Array.isArray(data)) return null;
    
    const item = data.find(item => item.value === value);
    return item ? item.key : null;
  }
  closeModal(): void {
    this.showModal = false;
    this.paymentSuccess = false;
  }
  updateApplicationStatus(): void {
     const draftStatusKey = this.findKeyByValue(this.applicationStatusData, 'SUBMITTED');
  let input = {
    application_id: this.applicationID,
    cd_application_status: draftStatusKey,
  }
   this.appService.updateApplicationStatus(input).subscribe({
      next: response => {
        if (response.data.success === true) {
          console.log('Application timeline created successfully:', response);
        } else {
          console.warn('Application timeline creation returned false success status');
        }
      },
      error: error => {
        console.error('Error creating application timeline:', error);
      }
    });

  }
  downloadPayment(rowData: any) {
    // Map rowData to the receipt template input structure
    const receiptData = {
      applicantName: rowData.cardName || '',
      applicationId: rowData.applicationId || '',
      referenceNumber: rowData.paymentId || rowData.payment_transaction_id || '',
      invoiceNumber: rowData.invoiceNumber || rowData.transaction_id || '',
      paymentMethod: 'Card',
      transactionDate: rowData.transactionDate || rowData.transaction_date || '',
      paymentAmount: rowData.amount || '',
    };
    this.commonService.generateReceiptPDF(receiptData, 'download');
  }

  
}
